// extracted by mini-css-extract-plugin
export default {"card":"MainCardItem_card__oYm2T"};